import type { Subscription } from '@factoryfixinc/ats-interfaces';
import { defineStore } from 'pinia';
import { computed, ref } from 'vue';
import type { UpgradeProposal } from './types/upgrade-proposal.type';
import type { UpgradeProposalTraits } from './types/upgrade-proposal-traits.type';

export const useSubscriptionV2Store = defineStore('subscription-v2', () => {
  const subscription = ref<Subscription>();
  const upgradeProposal = ref<UpgradeProposal | null>(null);

  const upgradeProposalTraits = computed<UpgradeProposalTraits | null>(() => {
    if (!upgradeProposal.value) return null;

    const { current, proposed, savings } = upgradeProposal.value;
    return {
      subscriptionPlanName: current.planName,
      subscriptionMonthlyPrice: current.monthlyAmount / 100,
      subscriptionGoldPrice: proposed.monthlyAmount / 100,
      subscriptionMonthlyPotentialSavings: savings.monthlyAmount / 100,
      subscriptionSavingsPercent: savings.percent,
      subscriptionCurrency: current.currency,
    };
  });

  // alphabetized list
  return {
    portalSessionUrl: ref<string>(),
    subscription,
    upgradeProposal,
    upgradeProposalTraits,
  };
});
